import { render, staticRenderFns } from "./XSXJXG.vue?vue&type=template&id=0c8ebac2&scoped=true"
import script from "./XSXJXG.vue?vue&type=script&lang=js"
export * from "./XSXJXG.vue?vue&type=script&lang=js"
import style0 from "./XSXJXG.vue?vue&type=style&index=0&id=0c8ebac2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8ebac2",
  null
  
)

export default component.exports